import Vue from 'vue'
import vuex from 'vuex'
Vue.use(vuex);

export default new vuex.Store({
  state: {
    tab: 0, //导航栏选中id
    avatar: '../../assets/head.png',
    alertExam: false, //登录后是否提醒参加考试
    subjectCode: 0, //报名考试课程id
    fixed: false, //通用--导航了是否固定
    Login: {
      login: false,
      modalclick: true, //是否可以通过点击遮罩层关闭login
      pwdSetting: false,
      forget: false
    }, //登录框显示
    user: {}, //用户信息
    isLogin: false, //是否登录
    auditionTitle: '', //试听课程名称
    auditionUrl: '', //试听课程路径
  },
  mutations: {
    setTab(state, tab) {
      state.tab = tab;
    },
    getUser(state, user) {
      state.user = user;
    },
    login(state) {
      state.Login.login = true;
    },
    out(state) {
      state.Login.login = false;
    },
    loginModel(state, status) {
      state.Login.modalclick = status;
    },
    setAuditionTitle(state, title) {
      state.auditionTitle = title;
    },
    setAuditionUrl(state, url) {
      state.auditionUrl = url;
    },
    setAlertExam(state) {
      state.alertExam = true;
    },
    setSubjectCode(state, id) {
      state.subjectCode = id;
    }
  },
  getters: {
    doneTodos: state => {
      return state.todos.filter(todo => todo.done)
    }
  },
  actions: {
    increment(context) {
      context.commit('increment')
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js